import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Image, Modal } from "../../../../../components";
import "./SelectSendInvoicesMethodModal.scss";
import { SEND_INVOICE_METHODS } from "../../../../../js/constants";

const SelectSendInvoicesMethodModal = props => {
	const { lang } = global;
	const { show, onHide, onSelected, selectedRecords } = props;

	const [methodSelected, setMethodSelected] = useState("");
	const [disableBulkSendV2Invoices, setDisableBulkSendV2Invoices] = useState(false);

	const selectedList = Object.values(selectedRecords);

	const onSendMethodChange = e => {
		setMethodSelected(e.target.value);
	};

	useEffect(() => {
		if (selectedList.length > 0) {
			const allV2 = selectedList.every(item => item.Version === 2);
			setDisableBulkSendV2Invoices(allV2);
		}
	}, [selectedList]);


	return (
		<Modal
			id="select-send-invoice-method-modal"
			show={show}
			onHide={() => onHide()}
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Send Method")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<span className="subtitle">
					{lang.t(
						"Please select which method you would like to use to send your invoices_",
					)}
				</span>
				<div className="flex flex-direction-column flex-gap-4 options-container">
					<div className="radio">
						<label htmlFor="send-method-individual">
							<input
								type="radio"
								value={SEND_INVOICE_METHODS.INDIVIDUAL}
								name="sendMethod"
								id="send-method-individual"
								onChange={onSendMethodChange}
								checked={methodSelected === SEND_INVOICE_METHODS.INDIVIDUAL}
								data-test-id="select-method-individual"
							/>
							{lang.t("Individual Send")}
						</label>
					</div>
					<p>
						{lang.t(
							"In a single transaction, multiple invoices will be emailed and individually payed by the recipients you choose_",
						)}
					</p>
					<Image src="/images/individual-send.png" />
					<div className="divider" />
					<div className="radio">
						<label htmlFor="send-method-group">
						<input
							type="radio"
							value={SEND_INVOICE_METHODS.GROUP}
							name="sendMethod"
							id="send-method-group"
							onChange={onSendMethodChange}
							checked={methodSelected === SEND_INVOICE_METHODS.GROUP}
							data-test-id="select-method-group"
							disabled={disableBulkSendV2Invoices}
							title={disableBulkSendV2Invoices ? lang.t("Group Send and Pay is not available for V2 invoices") : ""}
						/>
							{lang.t("Group Send and Pay")}
						</label>
					</div>

					<p>
						{lang.t(
							"In a single transaction, a group of invoices will be emailed and payed in one payment by the recipient you choose_",
						)}
					</p>
					<Image src="/images/group-send.png" />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					className="btn btn-primary"
					type="button"
					disabled={!methodSelected}
					onClick={() => onSelected(methodSelected)}
					data-test-id="select-method-continue-btn"
				>
					{lang.t("Continue")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

SelectSendInvoicesMethodModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	onSelected: PropTypes.func.isRequired,
	selectedRecords: PropTypes.object,
};

SelectSendInvoicesMethodModal.defaultProps = {
	show: false,
	onHide: () => {},
	selectedRecords: {},
};

export default SelectSendInvoicesMethodModal;
